import { Component, OnDestroy, OnInit } from '@angular/core';
import { AlertService, Alert } from '@edassist/shared';
import { Subscription } from 'rxjs';

@Component({
	selector: 'ea-global-alerts',
	styleUrls: ['./global-alerts.component.scss'],
	templateUrl: './global-alerts.component.html'
})
export class GlobalAlertsComponent implements OnInit, OnDestroy {
	alert: Alert;
	private readonly subscriptions: Subscription = new Subscription();

	constructor(private readonly alertService: AlertService) {}

	ngOnInit(): void {
		this.subscriptions.add(
			this.alertService.getAlert().subscribe((alert: Alert) => {
				this.alert = alert;
			})
		);
	}

	ngOnDestroy(): void {
		// unsubscribe to avoid memory leaks
		this.subscriptions.unsubscribe();
	}
}
